import { InlineConfig } from '../configs';

export type ExtendedInlineConfig = InlineConfig & {
  BACKEND_URL: string;
  ROOT_URL: string;
  IS_PANOMIO: string;
  SKIN_URL: string;
  PATH_TO_PUBLIC_FOLDER: string;
  USERNAME: string;
  PASSWORD: string;
}

export function dynamicEnv<K extends keyof ExtendedInlineConfig>(envVar: K): ExtendedInlineConfig[K] | undefined {
  const url = new URL(window.location.href);
  if (url.searchParams.has(envVar)) {
    return url.searchParams.get(envVar) as ExtendedInlineConfig[K];
  }

  /* if (fetchedConfig?.[envVar] !== undefined) {
       return fetchedConfig?.[envVar];
     }*/

  if (window?.inlineConfig?.[envVar] !== undefined) {
    return window?.inlineConfig?.[envVar];
  }

  if (process.env[`REACT_APP_${envVar}`] !== undefined) {
    return process.env[`REACT_APP_${envVar}`] as ExtendedInlineConfig[K];
  }

  return undefined;
}
